import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import home from './china/home'

const cn = {
    language: '简体中文',
    message: {
        'home': {
            ...home,
            'enterEmail': '请输入邮箱',
            'save': '保存',
            'saveSuccess': '保存成功',
            'pointHistory': '积分历史',
            'type': '类型',
            'remark': '备注',
            'pendingComment': '待评价',
            'commented': '已评价',
            'selectDate': '选择日期',
            'loginSuccess': '登录成功',
            'loginFail': '登录失败',
            'close': '关闭',
            'required': '必填',
            'nickname': '昵称',
            'enterNickname': '请输入昵称',
            'gender': '性别',
            'male': '男',
            'female': '女',
            'secret': '保密',
            'birthday': '生日',
            checkoutLoadFailed: '结算信息加载失败，请稍后重试',
            checkoutErrorTitle: '提示',
            goAddAddress: '去添加收货地址',
            shop_order_selectOrAddAddress: '请先添加收货地址，并设为默认地址后再结算',
            shop_order_cartEmpty: '购物车为空，无法结算',
            shop_order_cartHasNotActive: '存在未上架或无效商品，无法结算',
            shop_order_cartHasNotMarketable: '存在已下架商品，无法结算',
            shop_order_cartHasLowStock: '商品库存不足，无法结算',
            shop_order_cartHasExpiredGoods: '店铺商品已过期，无法结算',
            shop_order_typeIsNull: '订单类型无法识别，请检查商品类型',
            shop_order_goodsNotFound: '商品信息不存在或已删除',
            shop_order_giftNotForSale: '赠品不能直接购买结算',
            common_message_badRequest: '请求无效，请检查商品与参数',
        },
    },
    '手机号码最小长度为8位': "手机号码最小长度为8位。",
    '邮箱账号名称最小长度为6位': "邮箱账号名称最小长度为6位。",
    '邮箱只能包含英文，数字等字符': "邮箱只能包含英文，数字等字符",
    '请选择正确的收货地址': "请选择正确的收货地址。",
    // ===== 数据字典多语言 =====
    Dict_language_status_0: '禁用',
    Dict_language_status_1: '启用',
    Dict_member_label_type_1: '条件标签',
    Dict_member_label_type_2: '手动标签',
    Dict_member_level_type_0: '消费等级（LV）',
    Dict_member_level_type_1: '付费会员（VIP）',
    Dict_member_growth_action_type_1: '消费下单',
    Dict_member_growth_action_type_2: '每日登录',
    Dict_member_growth_action_type_3: '发布评价',
    Dict_member_growth_action_type_4: '完善资料',
    Dict_paid_member_payment_type_0: '余额支付',
    Dict_paid_member_payment_type_1: '微信支付',
    Dict_paid_member_payment_type_2: '支付宝',
    Dict_paid_member_payment_type_3: 'PayPal',
    Dict_paid_member_record_status_0: '有效',
    Dict_paid_member_record_status_1: '已到期',
    Dict_paid_member_record_status_2: '已退款',
    Dict_point_lottery_prize_type_0: '积分',
    Dict_point_lottery_prize_type_1: '优惠券',
    Dict_point_lottery_prize_type_2: '实物奖品',
    Dict_point_lottery_prize_type_3: '谢谢参与',
    Dict_notification_channel_type_0: '短信',
    Dict_notification_channel_type_1: '邮件',
    Dict_notification_channel_type_2: '站内信',
    Dict_notification_channel_type_3: 'Push推送',
    Dict_announcement_status_0: '草稿',
    Dict_announcement_status_1: '已发布',
    Dict_announcement_status_2: '已下架',
    Dict_live_permission_status_0: '未申请',
    Dict_live_permission_status_1: '审核中',
    Dict_live_permission_status_2: '已开通',
    Dict_live_permission_status_3: '已拒绝',
    Dict_live_room_status_0: '未开始',
    Dict_live_room_status_1: '直播中',
    Dict_live_room_status_2: '已结束',
    Dict_live_room_status_3: '异常中断',
    Dict_live_room_type_0: '平台直播',
    Dict_live_room_type_1: '商户直播',
    Dict_store_type_0: '个人店',
    Dict_store_type_1: '企业店',
    Dict_store_sign_status_0: '待签约',
    Dict_store_sign_status_1: '已签约',
    Dict_store_sign_status_2: '解约',
    Dict_store_business_change_status_0: '待审核',
    Dict_store_business_change_status_1: '审核通过',
    Dict_store_business_change_status_2: '审核拒绝',
    Dict_decoration_page_type_0: '首页',
    Dict_decoration_page_type_1: '分类页',
    Dict_decoration_page_type_2: '活动页',
    Dict_decoration_page_type_3: '自定义页',
    Dict_decoration_status_0: '草稿',
    Dict_decoration_status_1: '已发布',
    Dict_decoration_popup_trigger_page_0: '平台首页',
    Dict_decoration_popup_trigger_page_1: '会员中心',
    Dict_decoration_popup_trigger_page_2: '支付成功',
    Dict_decoration_popup_target_user_0: '所有用户',
    Dict_decoration_popup_target_user_1: '免费会员',
    Dict_decoration_popup_target_user_2: '付费会员',
    Dict_decoration_popup_frequency_0: '永久一次',
    Dict_decoration_popup_frequency_1: '每次进入',
    Dict_decoration_popup_frequency_2: '自定义频次',
    Dict_track_event_type_page_view: '页面访问',
    Dict_track_event_type_click: '点击',
    Dict_track_event_type_add_to_cart: '加入购物车',
    Dict_track_event_type_search: '搜索',
    Dict_track_event_type_purchase: '购买',
    Dict_track_event_type_live_watch: '观看直播',
    Dict_reconcile_period_type_0: '日',
    Dict_reconcile_period_type_1: '周',
    Dict_reconcile_period_type_2: '月',
    Dict_store_settlement_status_0: '待结算',
    Dict_store_settlement_status_1: '已结算',
    Dict_distributor_status_0: '待审核',
    Dict_distributor_status_1: '已审核',
    Dict_distributor_status_2: '已拒绝',
    Dict_distribution_commission_type_0: '直接佣金',
    Dict_distribution_commission_type_1: '间接佣金',
    Dict_configuration_status_0: '禁用',
    Dict_configuration_status_1: '启用',
    ...zhLocale
}

export default cn
